import React from 'react';
import styled from 'styled-components/macro';
import { Link } from 'react-router-dom';
import { isMobile } from 'react-device-detect';

const StyledFooter = styled.div`
  border-top: 1px solid #861657;
  width: 100%;
`;

const ContentWrapper = styled.div`
  /* /* min-width: 320px; */
  /* max-width: 1000px; */
  margin-left: auto;
  margin-right: auto;
  text-align: center;

  > a > :hover {
    color: ${() => (!isMobile ? '#93e1d8' : '')};
  }

  > a > :active {
    color: #93e1d8;
  }
`;

const StyledIcon = styled.i`
  font-size: 40px;
  color: #861657;
  /* color: ${(props) =>
    props.linkedin ? '#2867b2' : props.xing ? '#006567' : '#861657'}; */
  margin: 8px;
`;

const LinkWrapper = styled.div`
  font-family: Lato;
  font-weight: 400;
  font-style: normal;
  font-size: 12px;
  margin-bottom: 8px;
`;

const StyledLink = styled(Link)`
  color: #861657;
  margin: 0 4px;

  :hover {
    color: ${() => (!isMobile ? '#93e1d8' : '')};
  }

  :active {
    color: #93e1d8;
  }
`;

const Footer = () => {
  return (
    <StyledFooter>
      <ContentWrapper>
        <a href="mailto:info@peterfrommann.de" title="mail">
          <StyledIcon className="fa fa-envelope-square"></StyledIcon>
        </a>
        <a
          href="https://www.linkedin.com/in/peter-frommann-0013509/"
          title="linkedin"
        >
          <StyledIcon className="fa fa-linkedin-square"></StyledIcon>
        </a>
        {/* <a href="https://www.xing.com/profile/Peter_Frommann" target="_blank" rel="me"></a>> */}
        <a
          href="https://www.xing.com/profile/Peter_Frommann"
          rel="me"
          title="xing"
        >
          <StyledIcon className="fa fa-xing-square"></StyledIcon>
        </a>
        {/* <a href="https://www.behance.net/peterfrommann?tracking_source=search%7Cpeter%20frommann" title="behance">
          <StyledIcon className="fa fa-behance-square"></StyledIcon>
        </a> */}
        <LinkWrapper>
          © 2020 Peter Frommann.
          <StyledLink exact="true" to="/legals">
            Legals
          </StyledLink>
          <span>-</span>
          <StyledLink exact="true" to="/privacy-policy">
            Privacy Policy
          </StyledLink>
        </LinkWrapper>
      </ContentWrapper>
    </StyledFooter>
  );
};

export default Footer;
